import type { AssetColors } from '../../palette.js';

const OUTCROPS = [
  {
    shadow:
      'M-6.8,.3 -5,-5.6 -1.6,-7.2 -.4,-4.6 1.2,-11.9 4.5,-10.8 6.4,-6.3 6.8,.3 2.8,1.2 -1.9,.8Z',
    face: 'M-6.8,.3 -5,-5.6 -1.6,-7.2 -2.5,-2.4 -.9,.7Z M-.4,-4.6 1.2,-11.9 2.9,-8 2.3,-3.5 3.2,.8 -.1,.8Z',
    light: 'M-5,-5.6 -1.6,-7.2 -.4,-4.6 -2.5,-2.4Z M1.2,-11.9 4.5,-10.8 5.1,-7.4 2.9,-8Z',
    cracks: 'M2.9,-8 3.7,-5.9 2.7,-4.6 M-2.5,-2.4 -3.7,-1.9 -3.9,-.6 M5.1,-7.4 4.6,-4.8 5.3,-3.4',
    moss: 'M-6.8,.3 -5.5,-1.4 -4.1,-1.3 -3.4,-.2 -1.6,-.3 -1,.6 -3.8,1Z M2.3,-3.5 3.1,-4 4.1,-3.3 3.6,-2.4 2.8,-2.5Z M4.7,.4 5,-.8 6.4,-1.1 6.8,.3 5.7,.7Z',
    sprigs:
      'M-5,-.1 -5.2,-2.9 -4.6,-1.4 -3.8,-2.2 -4.1,-.3Z M4.9,.3 4.5,-1.8 5.1,-.9 5.7,-2.2 5.6,0Z',
  },
  {
    shadow:
      'M-7,.2 -6.5,-3.5 -3.2,-4.8 -1.5,-4.1 -.7,-6.9 2.5,-7.9 5.2,-6.2 4.5,-3.2 6.7,-1.4 6.2,.5 2.4,1.2 -.4,.8 -3.3,1.1Z',
    face: 'M-7,.2 -6.5,-3.5 -4.7,-2.4 -4.4,.6Z M-1.5,-4.1 -.7,-6.9 1.4,-5.2 .6,-2.1 2.4,-.8 2.4,1.2 -.4,.8 -1,-1.4Z',
    light:
      'M-6.5,-3.5 -3.2,-4.8 -1.5,-4.1 -2.3,-2.1 -4.7,-2.4Z M-.7,-6.9 2.5,-7.9 5.2,-6.2 3.3,-4.8 1.4,-5.2Z M.6,-2.1 4.5,-3.2 6.7,-1.4 2.4,-.8Z',
    cracks: 'M1.4,-5.2 2.3,-3.9 1.7,-2.5 M-4.7,-2.4 -4,-1.1 -4.4,.2 M4.1,-1.4 4,.5',
    moss: 'M-6.4,-3.5 -4.9,-4.1 -3.5,-3.5 -3.9,-2.6 -5.1,-2.5Z M-.5,-6.8 .8,-7.2 1.9,-6.7 1.1,-5.5 -.2,-5.9Z M-3.3,1.1 -2.5,-.1 -.9,-.3 -.4,.8Z M2.4,-.8 3.6,-1.2 5.3,-.4 4.5,.7 2.4,1.2Z',
    sprigs:
      'M-1.8,-.3 -2.2,-3 -1.4,-1.8 -.7,-3 -.9,-.6Z M3.1,-5.8 2.6,-8.6 3.3,-7.3 4,-8.1 3.8,-6.1Z',
  },
  {
    shadow:
      'M-6.5,.5 -5.5,-6.8 -3.8,-9.6 .8,-10.3 4.2,-8.1 6.7,-1.4 5.6,.7 3.6,.7 2.3,-4.5 .5,-6 -1.7,-5.5 -2.5,-3.7 -2.9,.4Z',
    face: 'M-6.5,.5 -5.5,-6.8 -3.8,-9.6 -2.6,-7.1 -3.6,-3.9 -3.8,.6Z M.8,-10.3 2.4,-7.2 4.1,-5.6 5.6,.7 3.6,.7 2.3,-4.5 .5,-6Z',
    light:
      'M-5.5,-6.8 -3.8,-9.6 .8,-10.3 2.4,-7.2 .5,-6 -1.7,-5.5 -2.6,-7.1Z M2.4,-7.2 4.2,-8.1 5.1,-5.7 4.1,-5.6Z',
    cracks: 'M-2.6,-7.1 -.9,-7.7 -.4,-9.4 M-4.4,-4.7 -5,-3.2 -4.5,-1.8 M4.1,-5.6 3.7,-4.4 4.6,-3',
    moss: 'M-6.5,.5 -5.6,-1 -4.4,-.9 -3.8,.6 -5.2,1.1Z M-3.8,-9.6 -2.1,-9.9 -1.3,-9.2 -2,-8.4 -3.2,-8.3Z M3.6,.7 3.5,-.4 4.8,-1 5.7,-.3 5.6,.7Z',
    sprigs: 'M-5,.1 -5.2,-2.4 -4.6,-1.2 -4.1,-2.7 -4,.1Z M4.5,.4 4.1,-1.6 4.7,-.7 5.4,-1.4 5.1,.4Z',
  },
] as const;

export function svgAlpineRocks(x: number, y: number, c: AssetColors, v: number): string {
  const rocks = OUTCROPS[v] ?? OUTCROPS[0];
  return (
    `<g transform="translate(${x},${y})">` +
    `<ellipse cx="0" cy=".5" rx="7.1" ry="1.1" fill="${c.shadow}" opacity=".13"/>` +
    `<path d="${rocks.shadow}" fill="${c.rock}"/><path d="${rocks.face}" fill="${c.boulder}"/>` +
    `<path d="${rocks.light}" fill="${c.cobble}"/>` +
    `<path d="${rocks.cracks}" fill="none" stroke="${c.shadow}" stroke-width=".2" opacity=".48"/>` +
    `<path d="${rocks.moss}" fill="${c.moss}"/><path d="${rocks.sprigs}" fill="${c.tallGrass}"/></g>`
  );
}
